import { RadioGroup, Radio, HStack, Text } from "@chakra-ui/react";

export default function ShowInscreenGraphic({
    inscreenGraphicOptions,
    value,
    onChange,
}) {
    return (
        <RadioGroup value={value} onChange={onChange}>
            <HStack spacing="20px">
                {inscreenGraphicOptions?.map((option) => (
                    <Radio
                        size="lg"
                        key={option.id}
                        value={option.value}
                    >
                        <Text fontSize="16px" fontWeight="400" m="0px" fontFamily="Roboto">
                            {option.label}
                        </Text>
                    </Radio>
                ))}
            </HStack>
        </RadioGroup>
    );
}
